export default __webpack_public_path__ + "static/media/compgg.096637d7.jpg";